import styled from 'styled-components';

export const Container = styled.section`
  border-radius: 4px;
  display: flex;
  font-family: 'Quicksand', sans-serif;
  font-weight: 200;
  height: 42px;
`;
Container.displayName = 'Container';

export const ColorsContainer = styled.div`
  border-radius: 4px;
  display: flex;
  height: 3px;
  margin-bottom: 4px;
  width: 100%;
`;
ColorsContainer.displayName = 'ColorsContainer';

export const ColorsItem = styled.div`
  flex-grow: 1;
`;
ColorsItem.displayName = 'ColorsItem';

export const Points = styled.div`
  background-color: #0c1a21;
  border: 1px solid #ccd8c2;
  border-radius: 4px;
  color: #ccd8c2;
  min-width: 40px;
`;
Points.displayName = 'Points';

export const PointContainer = styled.div`
  background-color: #0c1a21;
  border-radius: 4px;
  padding: 1px;
`;
PointContainer.displayName = 'PointContainer';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #0c1a21;
  display: flex;
  font-size: 30px;
  justify-content: center;
  min-width: 90px;
  padding: 0 8px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  padding: 0 12px;
`;
Space.displayName = 'Space';

export const TeamColor = styled.div`
  background-color: #f00;
  border-radius: 4px;
  height: 3px;
  margin-bottom: 4px;
  width: 100%;
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  background-color: #091a1a;
  box-sizing: content-box;
  color: #b5cfd5;
  font-size: 25px;
  letter-spacing: 3px;
  min-width: 85px;
  padding: 0 4px;
  text-align: center;

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #091a1a;
  color: #ccd8c2;
  display: flex;
  font-size: 38px;
  justify-content: center;
  min-width: 112px;
  text-align: center;

  &:first-child {
    border-radius: 4px 0 0 4px;
  }
`;
Timer.displayName = 'Timer';
